<template>
    <div
        :class="{ expanded: isExpanded }"
        class="special-event-item--terminal"
    >
        <div
            @click="onClick($event)"
            class="special-event-item__header--terminal"
        >
            <div class="special-event-item__date--terminal">
                {{ displayDate }}
            </div>
            <div class="special-event-item__header-event--terminal">
                <i class="icon icon-special"/>
                <span class="special-event-item__header-event-title--terminal">
                    {{ name }}
                </span>
            </div>
        </div>
        <div
            v-if="isExpanded && isFull"
            class="special-event-market__container"
        >
            <SpecialEvent
                :markets="markets"
                :name="name"
                :footer="footer"
                :header="header"
                :isResults="isResults"
                :selections="selections"
                @oddClick="(odd) => onOddClick(odd)"
                @headerClick="headerClick"
            />
        </div>
    </div>
</template>

<script>
    import { format } from 'date-fns';
    import SpecialEvent from './SpecialEvent';

    export default {
        name: 'SpecialEventScrollable',
        props: {
            isResults: {
                type: Boolean,
                required: true,
            },
            markets: {
                type: Array,
                required: false,
                default: null,
            },
            header: {
                type: String,
                required: false,
                default: '',
            },
            footer: {
                type: String,
                required: false,
                default: '',
            },
            selections: {
                type: Array,
                required: false,
                default: () => [],
            },
            id: {
                type: Number,
                required: true,
            },
            name: {
                type: String,
                required: false,
                default: '',
            },
            date: {
                type: Date,
                required: false,
            },
            isExpanded: {
                type: Boolean,
                required: true,
            },
            isFull: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        watch: {
            isExpanded() {
                this.changedOpenState = true;
            },
            isFull() {
                this.changedFullState = true;
            }
        },
        data() {
            return {
                changedOpenState: false,
                changedFullState: false,
            };
        },
        async updated() {
            if ((this.changedOpenState && this.isFull) || (this.changedFullState && this.isExpanded)) {
                this.changedOpenState = false;
                await this.$nextTick();
                this.$emit('rendered');
            }
        },
        computed: {
            displayDate() {
                return format(this.date, 'DD/MM/YYYY, hh:mm');
            }
        },
        methods: {
            onClick(clickEvent) {
                this.$emit('eventClick', this.id, clickEvent);
            },
            onOddClick(odd) {
                this.$emit('oddClick', odd);
            },
            headerClick() {
                this.$emit('collapse', this.id);
            },
        },
        components: {
            SpecialEvent
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/shared/special/SpecialEventScrollable.vue